//假设这里定义用户功能模块的api请求

//一般根据具体的接口服务模块约定
const baseURL = '/api';

export const aiconfigApi = {
    // 获取学校的AI配置 http://yapi.dm-ai.cn:3000/project/1072/interface/api/14640
    getAIConfig(opt: any) {
        var servicesPath = '/api/ecode/quota-rules';
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    //修改AI频次配置 http://yapi.dm-ai.cn:3000/project/1072/interface/api/14655
    editAIFrequency(opt: any) {
        var servicesPath = baseURL + '/ecode/quota-rules';
        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamsObj = opt.urlParamsObj || {};
        servicesPath += '/' + urlParamsObj.id + '/detail';

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            headers: {
                'content-type': 'application/json'
            },
            ajaxOpt: {
                //ajax的参数配置
                type: 'PATCH' //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    }
};
